import { getUint32, getUint16, uint8ArrayToString } from "@/utils/ByteUtils";

export class IresDeviceResponseReader {
  data: Uint8Array;
  currentIndex = 0;

  constructor(data?: Uint8Array, currentIndex?: number) {
    this.data = data ?? new Uint8Array();
    this.currentIndex = currentIndex ?? 0;
  }

  setNewData(data: Uint8Array) {
    this.data = data;
    this.currentIndex = 0;
  }

  readString(length: number) {
    const result = uint8ArrayToString(
      this.data.slice(this.currentIndex, this.currentIndex + length)
    );

    //Strings are escaped, so add one to length
    this.currentIndex += length + 1;

    return result;
  }

  skip(numValuesToSkip: number) {
    this.currentIndex += numValuesToSkip;
  }

  readBoolean() {
    return this.readUint8() !== 0;
  }

  readUint8() {
    const result = this.data[this.currentIndex++];
    return result;
  }

  readDate() {
    return new Date(this.readUint32() * 1000);
  }

  readMeterReading() {
    return this.readUint32() / 100.0;
  }

  readShortMeterReading() {
    return this.readUint16() / 100.0;
  }

  readBytes(numBytes: number) {
    const result = this.data.slice(
      this.currentIndex,
      this.currentIndex + numBytes
    );

    this.currentIndex += numBytes;

    return result;
  }

  readUint32() {
    const result = getUint32(this.data, this.currentIndex);

    this.currentIndex += 4;

    return result;
  }

  readUint16() {
    const result = getUint16(this.data, this.currentIndex);

    this.currentIndex += 2;

    return result;
  }

  readBitField(length: number) {
    let data = this.readUint8();
    const result: boolean[] = [];

    for (let i = 0; i < length; i++) {
      result.push(data % 2 === 1);
      data = data >>> 1;
    }

    return result;
  }
}
